import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminLayout, { scoreColor, eligBadge } from "./AdminLayout";
import api from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Checkbox } from "../../components/ui/checkbox";
import { BrainCircuit, GitCompare, ShieldAlert } from "lucide-react";

export default function Analysis() {
  const [rows, setRows] = useState([]);
  const [selected, setSelected] = useState([]);
  const navigate = useNavigate();

  useEffect(() => { api.get("/admin/candidates", { params: { sort: "highest_match" } }).then(({ data }) => setRows(data.candidates)); }, []);
  const toggle = (id) => setSelected((s) => s.includes(id) ? s.filter((x) => x !== id) : s.length < 5 ? [...s, id] : s);

  return (
    <AdminLayout title="Candidate Match Analysis" actions={
      <Button data-testid="compare-selected-button" disabled={selected.length < 2} onClick={() => navigate("/admin/compare", { state: { ids: selected } })} className="bg-[#C79A3B] text-[#101820] rounded-full font-semibold">
        <GitCompare className="h-4 w-4 mr-1" /> Compare ({selected.length})
      </Button>
    }>
      <div className="bg-[#C79A3B]/10 border border-[#C79A3B]/30 rounded-lg p-3 text-xs text-[#101820]/80 flex gap-2 items-start">
        <ShieldAlert className="h-4 w-4 text-[#8a6a1e] shrink-0 mt-0.5" />
        Ranked by transparent 100-point suitability score. Scores are decision-support only and never use protected characteristics. Select up to 5 candidates to compare side by side.
      </div>
      <div className="space-y-3">
        {rows.map((r, i) => (
          <div key={r.application_id} data-testid={`ranked-${r.application_id}`} className="bg-white rounded-lg border border-[#E4C675]/50 shadow-sm p-4 flex items-center gap-4 hover:shadow-md transition-shadow">
            <div className="text-2xl font-heading font-extrabold text-[#C79A3B] w-10 text-center">#{i + 1}</div>
            <Checkbox data-testid={`select-${r.application_id}`} checked={selected.includes(r.application_id)} onCheckedChange={() => toggle(r.application_id)} />
            <div className="flex-1 min-w-0 cursor-pointer" onClick={() => navigate(`/admin/candidates/${r.application_id}`)}>
              <div className="font-semibold text-[#101820]">{r.name}</div>
              <div className="text-xs text-muted-foreground">{r.current_role} · {r.current_employer} · {r.location}</div>
            </div>
            <span className={`text-xs px-2 py-1 rounded-full ${eligBadge(r.eligibility_status)}`}>{r.eligibility_status === "eligible" ? "Eligible" : r.eligibility_status === "review" ? "Review" : "Not Eligible"}</span>
            <div className="text-right">
              <span className={`inline-block font-mono-data font-bold text-lg px-3 py-1 rounded-md border ${scoreColor(r.match_score)}`}>{r.match_score}</span>
              <div className="text-[10px] text-muted-foreground mt-0.5">{r.match_label}</div>
            </div>
          </div>
        ))}
      </div>
    </AdminLayout>
  );
}
